import React from "react"
import Box from '@mui/material/Box';
import { leptin } from "../../../../../../../constants";

export const ImageLeptin = () => {

return(
<div>

<Box sx={{ mt:4, ml:8, }}>
                        <img 
                                    src={leptin}
                                    width="40%"
                                    height="auto"
                                    alt="leptin signaling"
                            />          
                        </Box>

</div>
)
}